import { production_app_url, uat_app_url, qa_set_env_flag } from '../config/constants';
import { config as productionConfig } from '../config/production';
import { config as qaConfig } from '../config/qa';
import { config as uatConfig } from '../config/uat';

export function isProduction(){
    return window.location.href.indexOf(production_app_url) !== -1;
}

export function isUAT(){
    return window.location.href.indexOf(uat_app_url) !== -1;
}

export function getEnvConfig(allowOverride = false){
    if(isProduction()){
        return productionConfig;
    }
    else if(isUAT()){
        return uatConfig;
    }
    else {
        // if qa flag is set, allow the user to use the report list for a different environment
        // needed so that QA can check URLs before they go to uat or production
        if(allowOverride && window.location.search.indexOf(qa_set_env_flag) !== -1){
            if(window.location.search.indexOf('env=production') !== -1){
                return productionConfig;
            }
            else if(window.location.search.indexOf('env=uat') !== -1){
                return uatConfig;
            }
        }
        return qaConfig;
    }
}


// WEBPACK FOOTER //
// ./src/utils/environment.js